<template>
  <el-dialog title="群组" :visible="visible" width="860px" @update:visible="updateVisible">
    <el-form :model="where" label-width="77px" class="ele-form-search" @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="小组名称">
            <el-input clearable v-model.trim="where.classname" placeholder="请输入" @keyup.enter.native="applyFilter" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <div class="ele-form-actions">
            <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="applyFilter">查询</el-button>
            <el-button @click="resetFilter">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <el-table
      ref="table"
      v-loading="tableLoading"
      :data="pageRows"
      row-key="id"
      border
      height="420"
      @selection-change="onSelectionChange">
      <el-table-column type="selection" width="45" align="center" />
      <el-table-column prop="classname" label="小组名称" min-width="140" align="center" show-overflow-tooltip />
      <el-table-column label="财务名称" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button
            type="text"
            size="small"
            @click.stop="openFinanceList(row)">查看[{{ financeRowsOf(row).length }}]</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="type_code" label="渠道类型" min-width="100" align="center">
        <template slot-scope="{ row }">
          <dict-tag dict-code="type_name" :value="row.type_code" />
        </template>
      </el-table-column>
      <el-table-column prop="hit" label="命中" width="90" align="center">
        <template slot-scope="{ row }">
          {{ row.hit }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="config-page"
      layout="total, prev, pager, next"
      :current-page.sync="page"
      :page-size="pageSize"
      :total="filteredRows.length"
      @current-change="syncSelection" />

    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>

    <el-dialog
      title="财务列表"
      :visible.sync="showFinanceList"
      width="560px"
      append-to-body
      :destroy-on-close="true"
      :lock-scroll="false"
      custom-class="ele-dialog-form">
      <div v-if="financeListTitle" class="ele-text-secondary" style="margin-bottom: 12px;">{{ financeListTitle }}</div>
      <el-form :model="{}" label-width="77px" class="ele-form-search" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :span="16">
            <el-form-item label="财务名称">
              <el-select
                v-model="addFinanceId"
                filterable
                clearable
                placeholder="请输入"
                class="ele-block"
                :loading="financeOptionsLoading"
                :disabled="financeSaving">
                <el-option
                  v-for="item in availableFinanceOptions"
                  :key="item.id"
                  :value="item.id"
                  :label="item.username" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="ele-form-actions">
              <el-button
                type="primary"
                icon="el-icon-plus"
                class="ele-btn-icon"
                :loading="financeSaving"
                :disabled="!addFinanceId"
                @click="addFinance">添加</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="financeListRows" border max-height="360" v-loading="financeSaving">
        <el-table-column type="index" label="序号" width="70" align="center" />
        <el-table-column label="财务名称" min-width="200" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.username }}[{{ row.account_count }}]
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{ row }">
            <el-popconfirm
              class="ele-action"
              title="确定移除该财务？"
              @confirm="removeFinance(row)">
              <el-button
                slot="reference"
                type="text"
                size="small"
                :disabled="!row.id || financeSaving">移除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="showFinanceList = false">关闭</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { parseIds, pageSlice } from './config-utils';

export default {
  name: 'ColumnConfigClass',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      where: { classname: '' },
      keyword: '',
      allRows: [],
      selectedIds: [],
      page: 1,
      pageSize: 50,
      loading: false,
      tableLoading: false,
      syncingSelection: false,
      showFinanceList: false,
      financeListTitle: '',
      financeListRows: [],
      financeListClass: null,
      financeSaving: false,
      financeOptions: [],
      financeOptionsLoading: false,
      addFinanceId: null
    };
  },
  computed: {
    filteredRows() {
      if (!this.keyword) return this.allRows;
      return this.allRows.filter((row) => String(row.classname || '').toLowerCase().includes(this.keyword));
    },
    pageRows() {
      return pageSlice(this.filteredRows, this.page, this.pageSize);
    },
    availableFinanceOptions() {
      const used = new Set(
        (this.financeListRows || []).map((row) => Number(row.id)).filter((id) => id > 0)
      );
      return (this.financeOptions || []).filter((item) => !used.has(Number(item.id)));
    }
  },
  mounted() {
    this.selectedIds = parseIds(this.data && this.data.resource_class_id);
    this.loadData();
    this.loadFinanceOptions();
  },
  methods: {
    financeRowsOf(row) {
      const ids = String((row && row.finance_id) || '')
        .split(',')
        .map((id) => Number(String(id).trim()))
        .filter((id) => id > 0);
      const names = String((row && row.finance_name) || '')
        .split(',')
        .map((name) => String(name).trim())
        .filter(Boolean);
      if (!ids.length && !names.length) {
        return [];
      }
      const len = Math.max(ids.length, names.length);
      const rows = [];
      for (let i = 0; i < len; i++) {
        rows.push({
          id: ids[i] || 0,
          username: names[i] || (ids[i] ? `财务ID:${ids[i]}` : undefined),
          account_count: null
        });
      }
      return rows;
    },
    loadFinanceAccountCounts() {
      const ids = (this.financeListRows || []).map((row) => Number(row.id)).filter((id) => id > 0);
      if (!ids.length) {
        return;
      }
      const typeCode = this.financeListClass && this.financeListClass.type_code;
      this.$http.get('/Resourceclass/getFinanceHitCounts', {
        params: { finance_ids: ids.join(','), type_code: typeCode }
      }).then((res) => {
        if (res.data.code !== 0) {
          return;
        }
        const map = res.data.data || {};
        this.financeListRows.forEach((item) => {
          const key = String(item.id);
          if (Object.prototype.hasOwnProperty.call(map, key)) {
            this.$set(item, 'account_count', Number(map[key]) || 0);
          } else {
            this.$set(item, 'account_count', 0);
          }
        });
      }).catch(() => {});
    },
    loadFinanceOptions() {
      this.financeOptionsLoading = true;
      this.$http.get('/Finance/getFinanceList').then((res) => {
        this.financeOptionsLoading = false;
        if (res.data.code !== 0) {
          this.financeOptions = [];
          this.$message.error(res.data.msg || '加载财务失败');
          return;
        }
        this.financeOptions = (res.data.data || []).map((item) => ({
          id: Number(item.id),
          username: item.username || `财务ID:${item.id}`
        }));
      }).catch((e) => {
        this.financeOptionsLoading = false;
        this.$message.error(e.message);
      });
    },
    openFinanceList(row) {
      this.financeListClass = row;
      this.financeListTitle = row && row.classname ? `小组：${row.classname}` : '';
      this.financeListRows = this.financeRowsOf(row);
      this.addFinanceId = null;
      this.showFinanceList = true;
      this.loadFinanceAccountCounts();
      if (!this.financeOptions.length) {
        this.loadFinanceOptions();
      }
    },
    addFinance() {
      if (!this.financeListClass || !this.financeListClass.id || !this.addFinanceId) {
        return;
      }
      const financeId = Number(this.addFinanceId);
      const picked = (this.financeOptions || []).find((item) => Number(item.id) === financeId);
      this.financeSaving = true;
      this.$http.post('/Resourceclass/addFinance', {
        id: this.financeListClass.id,
        finance_id: financeId
      }).then((res) => {
        this.financeSaving = false;
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg || '添加失败');
          return;
        }
        this.$message.success(res.data.msg || '已添加');
        const nextIds = String((res.data.data && res.data.data.finance_id) || '')
          .split(',')
          .map((id) => Number(String(id).trim()))
          .filter((id) => id > 0);
        const username = (res.data.data && res.data.data.username)
          || (picked && picked.username)
          || `财务ID:${financeId}`;
        const nameMap = {};
        this.financeListRows.forEach((item) => {
          if (item.id) nameMap[Number(item.id)] = item.username;
        });
        nameMap[financeId] = username;
        this.financeListClass.finance_id = nextIds.join(',');
        this.financeListClass.finance_name = nextIds.map((id) => nameMap[id] || `财务ID:${id}`).join(',');
        this.financeListRows = this.financeRowsOf(this.financeListClass);
        this.addFinanceId = null;
        this.loadFinanceAccountCounts();
        this.refreshHitCounts([this.financeListClass.id]);
        this.$emit('done');
      }).catch((e) => {
        this.financeSaving = false;
        this.$message.error(e.message);
      });
    },
    removeFinance(row) {
      if (!this.financeListClass || !this.financeListClass.id || !row || !row.id) {
        return;
      }
      this.financeSaving = true;
      this.$http.post('/Resourceclass/removeFinance', {
        id: this.financeListClass.id,
        finance_id: row.id
      }).then((res) => {
        this.financeSaving = false;
        if (res.data.code !== 0) {
          this.$message.error(res.data.msg || '移除失败');
          return;
        }
        this.$message.success(res.data.msg || '已移除');
        const nextIds = String((res.data.data && res.data.data.finance_id) || '')
          .split(',')
          .map((id) => Number(String(id).trim()))
          .filter((id) => id > 0);
        const nextNames = this.financeListRows
          .filter((item) => Number(item.id) !== Number(row.id))
          .map((item) => item.username);
        this.financeListClass.finance_id = nextIds.join(',');
        this.financeListClass.finance_name = nextNames.join(',');
        this.financeListRows = this.financeRowsOf(this.financeListClass);
        this.loadFinanceAccountCounts();
        this.refreshHitCounts([this.financeListClass.id]);
        this.$emit('done');
      }).catch((e) => {
        this.financeSaving = false;
        this.$message.error(e.message);
      });
    },
    loadData() {
      this.tableLoading = true;
      this.page = 1;
      this.$http.get('/Resourceclass/getClassList', { params: { lite: 1 } }).then((res) => {
        this.tableLoading = false;
        if (res.data.code !== 0) {
          this.allRows = [];
          this.$message.error(res.data.msg || '加载失败');
          return;
        }
        this.allRows = (res.data.data || []).map((item) => ({
          ...item,
          id: Number(item.id),
          hit: null
        }));
        this.$nextTick(() => this.syncSelection());
        this.refreshHitCounts(this.allRows.map((item) => item.id));
      }).catch((e) => {
        this.tableLoading = false;
        this.$message.error(e.message);
      });
    },
    refreshHitCounts(ids) {
      const idList = (ids || []).map((id) => Number(id)).filter((id) => id > 0);
      if (!idList.length) {
        return;
      }
      this.$http.get('/Resourceclass/getHitCounts', { params: { ids: idList.join(',') } }).then((res) => {
        if (res.data.code !== 0) {
          return;
        }
        const map = res.data.data || {};
        this.allRows.forEach((item) => {
          const key = String(item.id);
          if (Object.prototype.hasOwnProperty.call(map, key)) {
            this.$set(item, 'hit', Number(map[key]) || 0);
          }
        });
      }).catch(() => {});
    },
    applyFilter() {
      this.keyword = (this.where.classname || '').trim().toLowerCase();
      this.page = 1;
      this.$nextTick(() => this.syncSelection());
    },
    resetFilter() {
      this.where.classname = '';
      this.keyword = '';
      this.page = 1;
      this.$nextTick(() => this.syncSelection());
    },
    syncSelection() {
      const table = this.$refs.table;
      if (!table) return;
      this.syncingSelection = true;
      const selected = new Set(this.selectedIds);
      table.clearSelection();
      this.pageRows.forEach((row) => {
        if (selected.has(Number(row.id))) table.toggleRowSelection(row, true);
      });
      this.$nextTick(() => { this.syncingSelection = false; });
    },
    onSelectionChange(rows) {
      if (this.syncingSelection) return;
      const visible = new Set(this.pageRows.map((r) => Number(r.id)));
      const kept = this.selectedIds.filter((id) => !visible.has(id));
      const current = (rows || []).map((r) => Number(r.id)).filter(Boolean);
      this.selectedIds = Array.from(new Set(kept.concat(current)));
    },
    save() {
      if (!this.data || !this.data.id) return;
      this.loading = true;
      this.$http.post('/ChannelColumnIn/edit', {
        id: this.data.id,
        resource_class_id: this.selectedIds.join(',')
      }).then((res) => {
        this.loading = false;
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.updateVisible(false);
          this.$emit('done');
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>

<style scoped>
.config-page {
  margin-top: 12px;
  text-align: right;
}
</style>
